import { render, staticRenderFns } from "./ItemRewardsReport.vue?vue&type=template&id=c52719a2&scoped=true"
import script from "./ItemRewardsReport.vue?vue&type=script&lang=js"
export * from "./ItemRewardsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52719a2",
  null
  
)

export default component.exports